import React from "react";
import infoConstants from "../../../shared/infoConstants";

import StyledFooter from "./StyledFooter";

const Footer = () => {
  return (
    <StyledFooter>
      <div className="wrapper-footer">
        <div className="center center-notLoggedIn">
          <div className="font-size-14">
            For technical issues, contact HealthBeacon at{" "}
            <a href={`mailto: ${infoConstants.patientSafetyHubEmail}`}>
              {infoConstants.patientSafetyHubEmail}
            </a>{" "}
            or call{" "}
            <a href={`tel:${infoConstants.patientSafetyHubPhoneNumber}`}>
              {infoConstants.patientSafetyHubPhoneNumber}
            </a>
          </div>
        </div>
      </div>
    </StyledFooter>
  );
};
export default Footer;
